<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M14.700234375,7.290000009536743C14.700234375,7.290000009536743,9.700234375,2.290000009536743,9.700234375,2.290000009536743C9.520234375,2.100000009536743,9.270234375,1.9900000095367432,8.990234375,1.9900000095367432C8.440234375,1.9900000095367432,7.990234375,2.4400000095367433,7.990234375,2.990000009536743C7.990234375,3.2700000095367434,8.100234375,3.5200000095367434,8.280234375,3.700000009536743C8.280234375,3.700000009536743,11.570234375,6.990000009536743,11.570234375,6.990000009536743C11.570234375,6.990000009536743,1.990234375,6.990000009536743,1.990234375,6.990000009536743C1.440234375,6.990000009536743,0.990234375,7.440000009536743,0.990234375,7.990000009536743C0.990234375,8.540000009536744,1.440234375,8.990000009536743,1.990234375,8.990000009536743C1.990234375,8.990000009536743,11.580234375,8.990000009536743,11.580234375,8.990000009536743C11.580234375,8.990000009536743,8.290234375,12.280000009536742,8.290234375,12.280000009536742C8.110234375000001,12.460000009536744,8.000234375,12.710000009536744,8.000234375,12.990000009536743C8.000234375,13.540000009536744,8.450234375,13.990000009536743,9.000234375,13.990000009536743C9.280234375,13.990000009536743,9.530234375,13.880000009536744,9.710234375,13.700000009536744C9.710234375,13.700000009536744,14.710234375,8.700000009536744,14.710234375,8.700000009536744C14.890234375,8.520000009536744,15.000234375,8.270000009536744,15.000234375,7.990000009536743C15.000234375,7.710000009536743,14.880234375,7.470000009536744,14.700234375,7.290000009536743C14.700234375,7.290000009536743,14.700234375,7.290000009536743,14.700234375,7.290000009536743Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ArrowRight',
} as DefineComponent
</script>
